// extracted by mini-css-extract-plugin
export default {"wrapper":"JudgeCard_wrapper__WBmcb","unlockable":"JudgeCard_unlockable__yFiZN","blur":"JudgeCard_blur__pgV78","textWrapper":"JudgeCard_textWrapper__xFCWx"};